import React from "react";
import { AiOutlineRight } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import "../../container.css";
import { getUserNameAvartar } from "../../../utils/helpers/dataHelper";

export default function CareerTab({ image, name, desc, link, data }) {
  const history = useHistory();
  return (
    <div
      className="mb-8 border-b-2 cursor-pointer"
      onClick={() => history.push({ state: data, pathname: link })}
    >
      <div className="flex m-4">
        <div>
          {image === undefined ? (
            <div className="bg-green-800 rounded-full p-3 text-white font-bold">
              {getUserNameAvartar(name)}
            </div>
          ) : (
            <img className="h-12 w-12" src={image} alt="career_img" />
          )}
        </div>
        <div className="px-2">
          <div className="font-bold">{name}</div>
          <div className="two_line">{desc}</div>
        </div>
        <div className="mt-auto mb-auto ml-auto">
          <AiOutlineRight />
        </div>
      </div>
    </div>
  );
}
